import React from 'react'
import Typewriter from  'typewriter-effect'

const About = () => {
  return (
    <div className='text-white' id="about">
        <div className="flex flex-col justify-center mx-auto mt-50 w-full h-screen bg-black text-center">
          <p className='text-green-500 uppercase text-xs'>Growing with data analytics</p>
          <h1 className='text-white text-4xl font-bold p-1'>Grow with data</h1>
          <div className='flex w-full items-center justify-center p-1 text-xl text-[gray]'>
            <p className='mr-1 text-white'>Fast, flexible financing for</p>
            <Typewriter 
              options={{
                autoStart:true,
                loop:true,
                delay:40,
                strings:[
                 "BTC BTB SASS",
                 "ADA SOL ETH"
               ]
             }}
            />
          </div>
          <p className='text-[gray] p-1'>Monitor your data analytics to increase revenue for BTB, BTC & SASS platform</p>
          <button className="btn hover:scale-105 duration-500">Get Started</button>
        </div>
    </div>
  )
}

export default About